import { FormApi } from 'informed';

import { AllFormFieldModelsType } from '../../types/FieldModelTypes';

type FormApiWithEmitter = FormApi & {
  emitter?: {
    on: (event: string, cb: () => void) => void;
    removeListener: (event: string, cb: () => void) => void;
  };
  screenValid?: () => boolean;
};

export const isCurrentStepValid = (
  formApi: FormApi,
  stepFields: AllFormFieldModelsType[]
): boolean => {
  const screenValidFn = (formApi as FormApiWithEmitter).screenValid;

  if (screenValidFn) {
    return screenValidFn();
  }

  return stepFields.every((field) => !formApi.getError(field.field));
};

export const runAfterFormValidation = (
  formApi: FormApi,
  callback: () => void,
  triggerValidation: () => void
): void => {
  const formApiWithEmitter = formApi as FormApiWithEmitter;

  const invokeWhenValidationSettles = (): void => {
    const formState = formApi.getState() as { validating?: number };

    if (formState.validating) {
      const onValidationChange = (): void => {
        const nextFormState = formApi.getState() as { validating?: number };

        if (!nextFormState.validating) {
          formApiWithEmitter.emitter?.removeListener(
            'change',
            onValidationChange
          );
          callback();
        }
      };

      formApiWithEmitter.emitter?.on('change', onValidationChange);
      return;
    }

    callback();
  };

  triggerValidation();
  setTimeout(invokeWhenValidationSettles, 0);
};

export const runValidationAndProceed = (
  formApi: FormApi,
  isStepValid: () => boolean,
  onValid: () => void
): void => {
  formApi.validate();

  const proceedIfValid = (): void => {
    if (isStepValid()) {
      onValid();
    }
  };

  const formState = formApi.getState() as { validating?: number };

  if (formState.validating) {
    const onValidationChange = (): void => {
      const nextFormState = formApi.getState() as { validating?: number };

      if (!nextFormState.validating) {
        (formApi as FormApiWithEmitter).emitter?.removeListener(
          'change',
          onValidationChange
        );
        proceedIfValid();
      }
    };

    (formApi as FormApiWithEmitter).emitter?.on('change', onValidationChange);
    return;
  }

  Promise.resolve().then(proceedIfValid);
};
